import React, { useState } from "react";
import Modal from "../Modal";
import { accountService } from "../../../Services";
import AppButton from "../../AppButton";

export default function ModalSwitch(props) {
  const [loading, setLoading] = useState(null);

  const clickHandler = (type, id) => {
    setLoading(id);
    props.setChangePage(type);
    if (type === "advertiser") switchProfile(id, "brand");
    if (type === "influencer") switchProfile(id, "influencer");
    if (type === "admin") switchProfile(id, "admin");
  };

  async function switchProfile(id, type) {
    try {
      await accountService.switchProfile(
        { role_id: id },
        () => (window.location.href = `/#/${type}/dashboard`)
      );
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <Modal addClass="modalFunds" close={props.close}>
      <div className="modal__swap rounded-xl p-8 bg-white shadow-lg max-w-lg mx-auto">
        {/* Title Section */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Switch Account</h2>
          <p className="text-gray-500 text-sm mt-1">
            Choose the profile you want to continue with
          </p>
        </div>

        {/* Profile Options */}
        <div className="flex flex-col gap-8">
          {props?.profiles.map((item, index) => {
            if (item?.active) return null;
            return (
              <div
                key={index}
                className="flex flex-col items-center bg-green-50 p-6 rounded-xl shadow-sm hover:shadow-md transition"
              >
                {/* Avatar (unchanged) */}
                <div className="justify-center mb-8">
                  <img
                    className=" "
                    style={{ width: "120px", height: "120px" }}
                    src={
                      item.image && item.image !== ""
                        ? item.image
                        : `${process.env.PUBLIC_URL}/images/Switch_Account2.png`
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                    }}
                    alt="avatar"
                  />
                </div>

                {/* Account Name */}
                <div className="text-center mb-4">
                  <h3 className="text-lg font-semibold text-gray-700 capitalize">
                    {item?.name !== "advertiser" ? "Brand" : "Influencer"}
                  </h3>
                </div>

                {/* Switch Button */}
                <AppButton
                  className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-700 px-6 py-2 rounded-lg text-white font-medium shadow-md disabled:opacity-50"
                  onClick={() => clickHandler(item?.name, item?.id)}
                  disabled={loading === item?.id}
                >
                  {loading === item?.id ? (
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Switching...
                    </div>
                  ) : item?.name === "advertiser" ? (
                    "Switch to Brand Account"
                  ) : item?.name === "influencer" ? (
                    "Switch to Influencer Account"
                  ) : (
                    "Switch Account"
                  )}
                </AppButton>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
}
